import { bridge } from "@multiweb/reactCore/bridge";
import { createLoadLocalizationKeysAction } from "./actions";
import { DEFAULT_FETCHING_KEY } from "./constants";
import { hasLocalization } from "./selectors";

const { dispatchAction, getState } = bridge;

/**
 * Utility pro externí použití mimo modul. Obsah nemůže být v utils, protože vyžaduje funkcionalitu modulu, která utils používá (např. selectory)
 * a vznikla by tak cyklická závislost.
 */

/**
 * Načte lokalizační klíč do core/i18n modulu, pokud ještě načtený není. Využívá batchování požadavků na načtení lokalizací.
 *
 * Před použitím zvažte možnost použít komponentu {@link LocalizationLoader} a zvažte, který přístup se pro vaše použití hodí více.
 *
 * Využívá funkce z core/bridge modulu. Tato funkce je určená pro použití v původní aplikaci a v konektorech. V reactové části se používat nesmí.
 * V reactové části se pro načtení lokalizace používá akce {@link createLoadLocalizationKeysAction} přímo, nemá důvod být závislá na
 * bridge modulu.
 *
 * @param locKey Klíč k načtení.
 * @param fetchingKey Klíč pro fetching modul, pod kterým bude indikováno načítání.
 * Pokud není zadaný, použije se výchozí hodnota sdílená pro všechny LocalizationLoader a LocalizationMultiLoader komponenty.
 */
export const loadLocalizationIfNeeded = (locKey: string, fetchingKey: string = DEFAULT_FETCHING_KEY) => {
    const isKeyLoaded = hasLocalization(getState(), locKey);
    if (!isKeyLoaded) {
        dispatchAction(createLoadLocalizationKeysAction([locKey], fetchingKey, true));
    }
};
